import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'studenttype'
})
export class StudenttypePipe implements PipeTransform {

  transform(wp: unknown): unknown {
    switch(wp){
      case 'trainee':
        return 'Harjoittelija';
      case 'specialty':
        return 'Erikoistuva';
      case 'no':
        return '';
      default:
        return '';
    }
  }

}
